<div class="chat-interface" [class.visible]="isVisible">
  <div class="chat-header">
    <div class="chat-header-info">
      <div class="ai-avatar">
        <div class="avatar-icon">🤖</div>
        <div
          class="status-dot"
          [class.online]="!isTyping"
          [class.typing]="isTyping"
        ></div>
      </div>
      <div class="chat-title-area">
        <h3 class="chat-title">Markado AI Assistant</h3>
        <div class="chat-status">{{ getStatusText() }}</div>
      </div>
    </div>
    <div class="chat-header-actions">
      <button
        class="header-action-btn help-btn"
        (click)="handleShowHelp()"
        title="Show Help"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </button>
      <button
        class="header-action-btn close-btn"
        (click)="handleCloseChat()"
        title="Close Chat"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>

  <div
    #messagesContainer
    class="messages-container"
    [class.has-messages]="messages.length > 0"
  >
    <div class="welcome-screen" [class.hidden]="messages.length > 0">
      <h4 class="welcome-title">Hello! I'm your AI assistant</h4>
      <p class="welcome-description">
        I can help you search for listings, answer questions about Markado, and
        assist with anything you need. How can I help you today?
      </p>

      <div class="quick-actions">
        <div class="quick-actions-title">Try asking me:</div>
        <div class="quick-actions-grid">
          <button
            *ngFor="let action of quickActions"
            class="quick-action-btn"
            (click)="handleQuickAction(action.message)"
            [title]="action.message"
          >
            <span class="action-icon">{{ action.icon }}</span>
            <span class="action-text">{{ action.text }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="messages-list" [class.visible]="messages.length > 0">
      <div
        *ngFor="let message of messages; trackBy: trackMessage"
        class="message"
        [class.user]="message.role === 'user'"
        [class.assistant]="message.role === 'assistant'"
        [class.error]="message.error"
      >
        <div class="message-avatar">
          <div class="avatar-icon" [class.user]="message.role === 'user'">
            {{ message.role === "user" ? "👤" : "🤖" }}
          </div>
        </div>

        <div class="message-content">
          <div
            class="message-text"
            [innerHTML]="formatMessage(message.content) | parseListingLinks"
          ></div>
          <div class="message-time">{{ formatTime(message.timestamp) }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="input-area">
    <div class="input-container">
      <textarea
        #messageInput
        class="message-input"
        [(ngModel)]="currentMessage"
        (keydown)="onKeyDown($event)"
        (input)="onInputChange($event)"
        placeholder="Ask me anything"
        rows="1"
        maxlength="2000"
      ></textarea>

      <div class="input-actions">
        <button
          class="send-btn"
          (click)="handleSendMessage()"
          [disabled]="!canSendMessage()"
          title="Send Message"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22,2 15,22 11,13 2,9 22,2"></polygon>
          </svg>
        </button>
      </div>
    </div>

    <div class="input-footer">
      <div
        class="character-count"
        [class.warning]="currentMessage.length > 1800"
      >
        {{ currentMessage.length }}/2000
      </div>
      <div class="powered-by">Powered by Markado AI</div>
    </div>
  </div>
</div>

<div
  class="error-overlay"
  [class.visible]="showErrorMessage"
  (click)="handleDismissError()"
>
  <div class="error-modal" (click)="$event.stopPropagation()">
    <div class="error-icon">⚠️</div>
    <h4>Something went wrong</h4>
    <p>{{ errorMessage }}</p>
    <button class="error-dismiss-btn" (click)="handleDismissError()">
      Dismiss
    </button>
  </div>
</div>

<div
  class="confirm-overlay"
  [class.visible]="showConfirmDialog"
  (click)="handleCancelConfirm()"
>
  <div class="confirm-modal" (click)="$event.stopPropagation()">
    <div class="confirm-icon">❓</div>
    <h4>{{ confirmDialogTitle }}</h4>
    <p>{{ confirmDialogMessage }}</p>
    <div class="confirm-actions">
      <button class="confirm-cancel-btn" (click)="handleCancelConfirm()">
        Cancel
      </button>
      <button class="confirm-action-btn" (click)="handleConfirmAction()">
        {{ confirmDialogActionText }}
      </button>
    </div>
  </div>
</div>
